enum PaymentUserAccessLevel {
  Invoices = 'Invoices',
  Membership = 'Membership',
  Full = 'MembershipAndInvoices',
  None = 'None',
}
export default PaymentUserAccessLevel;
